import http from 'conversations-http/clients/http';
export const getProductInfo = () => http.get('/app-users/v1/sales-products/product-info');